/**
 * The BLUNT "high" screen filter: while the local player is smoking (synced Player.smoking,
 * ~20s), the world view goes woozy — oversaturated, hue-tilted, softly blurred — under a slowly
 * breathing purple/green vignette. Pure DOM: a fixed overlay with backdrop-filter over the 3D
 * canvas, BELOW the HUD/panels (z-index) so the UI stays readable. Eases in/out on toggle.
 */

const STYLE_ID = "ghostland-high-style";
const CSS = `
#gl-high-overlay { position: fixed; inset: 0; z-index: 10; pointer-events: none; }
#gl-high-warp {
  position: absolute; inset: 0;
  backdrop-filter: none; -webkit-backdrop-filter: none;
  transition: backdrop-filter 2.2s ease, -webkit-backdrop-filter 2.2s ease;
}
#gl-high-overlay.on #gl-high-warp {
  backdrop-filter: saturate(1.5) hue-rotate(8deg) blur(1.4px);
  -webkit-backdrop-filter: saturate(1.5) hue-rotate(8deg) blur(1.4px);
}
#gl-high-vignette {
  position: absolute; inset: -6%;
  opacity: 0; transition: opacity 2.2s ease;
  background: radial-gradient(ellipse at 50% 55%,
    rgba(0,0,0,0) 42%,
    rgba(128,64,208,0.22) 74%,
    rgba(48,168,96,0.34) 100%);
}
#gl-high-overlay.on #gl-high-vignette { opacity: 1; animation: gl-high-breathe 5.5s ease-in-out infinite; }
@keyframes gl-high-breathe {
  0%, 100% { transform: scale(1); filter: hue-rotate(0deg); opacity: .85; }
  50%      { transform: scale(1.045); filter: hue-rotate(-30deg); opacity: 1; }
}
@media (prefers-reduced-motion: reduce) {
  #gl-high-overlay.on #gl-high-vignette { animation: none; }
}
`;

let overlay: HTMLDivElement | null = null;
let on = false;

function ensure(): HTMLDivElement {
  if (overlay) return overlay;
  const style = document.createElement("style");
  style.id = STYLE_ID;
  style.textContent = CSS;
  document.head.appendChild(style);
  overlay = document.createElement("div");
  overlay.id = "gl-high-overlay";
  overlay.innerHTML = `<div id="gl-high-warp"></div><div id="gl-high-vignette"></div>`;
  document.body.appendChild(overlay);
  return overlay;
}

/** Drive from the render loop with the local player's synced `smoking` flag (idempotent). */
export function setHighVisible(smoking: boolean): void {
  if (smoking === on) return;
  on = smoking;
  ensure().classList.toggle("on", smoking);
}
